import styled from '@emotion/styled';
import { Box, Grid, Link, Paper, Tooltip, Typography } from '@material-ui/core';
import Help from '@material-ui/icons/Help';
import { createElement, FC, Fragment, SyntheticEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import ProjectAssetEditor from '../../../../component/compound/ProjectAssetEditor/ProjectAssetEditor';
import LfToBr from '../../../../component/primitive/LfToBr';
import { SPACING_HUGE, SPACING_REGULAR, SPACING_UNIT } from '../../../../constant/spacing';
import mq from '../../../../styleUtility/mediaquery';
import { DynamicSchemaValue } from '../../../../types/DynamicSchema';
import RequiredLabel from './RequiredLabel';

type Props = {
  bucketId: string;
  assetCategoryValue: DynamicSchemaValue;
  onChangeAssetCategoryValue: (e: SyntheticEvent<HTMLElement>, value: DynamicSchemaValue) => void;
};

const CreativeBriefAssetFilesBlock: FC<Props> = ({ bucketId, assetCategoryValue, onChangeAssetCategoryValue }) => {
  return (
    <>
      <Heading variant="h5">
        <FormattedMessage id="project_editing_page.creative_brief.assets.title" />
      </Heading>
      {assetCategoryValue.definition.sections.map((section) => (
        <Container key={section.id}>
          <Grid container justifyContent="space-between">
            <Grid item>
              {section.label !== '' ? (
                <Heading variant="h5">
                  {section.label}
                  {section.meta != null && section.meta.isRequired === true && <RequiredLabel />}
                </Heading>
              ) : (
                section.meta != null && section.meta.isRequired === true && <RequiredLabel />
              )}
            </Grid>
            {section.meta != null && section.meta.helperUrl != null && (
              <Grid item>
                <Link href={section.meta.helperUrl} target="_blank">
                  <Tooltip title={section.meta?.helperTooltip ?? ''} placement="bottom-end">
                    <Help color="disabled" />
                  </Tooltip>
                </Link>
              </Grid>
            )}
          </Grid>
          <CategoryDescription marginY={2} padding={2}>
            <Typography>
              <LfToBr text={section.description} />
            </Typography>
          </CategoryDescription>
          <ProjectAssetEditor
            section={section}
            value={assetCategoryValue}
            bucketId={bucketId}
            onChange={onChangeAssetCategoryValue}
          />
        </Container>
      ))}
    </>
  );
};

const Heading = styled(Typography)`
  margin-bottom: ${SPACING_UNIT}px;

  ${mq('sp')} {
    font-size: 1.3rem;
  }
`;

const Container = styled(Paper)`
  margin-top: ${SPACING_REGULAR}px;
  margin-bottom: ${SPACING_HUGE}px;
  padding: ${SPACING_REGULAR}px;
`;

const CategoryDescription = styled(Box)`
  background-color: #fafafa;
`;

export default CreativeBriefAssetFilesBlock;
